import { combineReducers } from 'redux';
import { poiReducer } from './poi/poi.reducer';
import { itinReducer } from './itinerari/itinerari.reducer';
import { userReducer } from './users/users.reducer';
import { themesReducer } from './themes/themes.reducer';
import { geoposReducer } from './geographicalpos/geographicalpos.reducer';
import { loggedReducer } from './logged/logged.reducer';

export default function reduceReducers(...reducers) {
    return (previous, current) =>
        reducers.reduce(
            (p, r) => r(p, current),
            previous
        );
}

export const rootReducer = reduceReducers(
    combineReducers({
        poi : poiReducer,
        itin : itinReducer,
        user : userReducer,
        logged: loggedReducer,
        theme : themesReducer,
        geopos : geoposReducer,
    })
);
